import { SharingDraft } from '@/types';
import { getMementoKey } from './getMementoKey';

export const loadFromStorage = (id: string, platform: string) => {
  const json = window.localStorage.getItem(getMementoKey(id, platform));
  return json ? (JSON.parse(json) as SharingDraft) : undefined;
};
